/*
 * Apollo Link for additional requests error handling
 * Docs: https://www.apollographql.com/docs/link/links/error.html
 */
import { onError } from 'apollo-link-error';
import { GraphQLError } from '../errors';

// Apollo Link networkError type is just an error,
// but its clear JS contains info about statuScode, response and result
// that we want to use in error handler
//
// Github issue discussion: https://github.com/apollographql/apollo-link/issues/300#issuecomment-387120102

export var createErrorLink = function createErrorLink(_ref) {
  var statusCodeHandlers = _ref.statusCodeHandlers;
  return onError(function (errorResponse) {
    var networkError = errorResponse.networkError;
    var graphQLErrors = errorResponse.graphQLErrors;
    if (graphQLErrors) {
      // Our existing GraphQLError has its own type, and graphql one is not exposing the type information correctly
      // So in here we gonna go with `any` type for now
      // eslint-disable-next-line no-console
      console.error(GraphQLError.from(errorResponse.graphQLErrors));
    }
    if (networkError) {
      var statusCode = networkError.statusCode;
      var handler = statusCodeHandlers[statusCode];
      if (typeof handler === 'function') {
        /**
         * these functions are expecting a Response object, which is not present here.
         * It appears statusCodeHandlers are never passed to createErrorLink, so we should investigate removal
         */
        // @ts-ignore
        handler();
        return;
      }
    }
  });
};